import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  Route,
} from '@angular/router';
import { DashboardMainContentService } from '../../../services/dashboard-main-content';

const useFullDashboardContentWidth: CanActivateChildFn = (childRoute) => {
  if (!childRoute.routeConfig?.path) {
    return true;
  }

  inject(DashboardMainContentService).setMaxWidth('100%');
  return true;
};

export const routes: Route[] = [
  {
    path: 'reports',
    canActivateChild: [useFullDashboardContentWidth],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadComponent: () => import('./reports').then(({ ReportsPage }) => ReportsPage),
      },
      {
        path: 'all-takeoffs',
        loadComponent: () =>
          import('./all-takeoffs/all-takeoffs').then(({ AllTakeoffsPage }) => AllTakeoffsPage),
      },
      {
        path: 'take-off-ready-for-release',
        loadComponent: () =>
          import('./take-off-ready-for-release/take-off-ready-for-release').then(
            ({ TakeOffReadyForReleasePage }) => TakeOffReadyForReleasePage,
          ),
      },
      {
        path: 'vendor-releases',
        loadComponent: () =>
          import('./vendor-releases/vendor-releases').then(
            ({ VendorReleasesPage }) => VendorReleasesPage,
          ),
      },
      {
        path: 'demo-metal-comparison',
        loadComponent: () =>
          import('./demo-metal-comparison/demo-metal-comparison').then(
            ({ DemoMetalComparisonPage }) => DemoMetalComparisonPage,
          ),
      },
      {
        path: 'missing-rules',
        loadComponent: () =>
          import('./missing-rules/missing-rules').then(({ MissingRulesPage }) => MissingRulesPage),
      },
      {
        path: 'changes-since-release',
        loadComponent: () =>
          import('./changes-since-release/changes-since-release').then(
            ({ ChangesSinceReleasePage }) => ChangesSinceReleasePage,
          ),
      },
      {
        path: 'callout-history',
        loadComponent: () =>
          import('./callout-history/callout-history').then(
            ({ CalloutHistoryPage }) => CalloutHistoryPage,
          ),
      },
      {
        path: 'project-change-log',
        loadComponent: () =>
          import('./project-change-log/project-change-log').then(
            ({ ProjectChangeLogPage }) => ProjectChangeLogPage,
          ),
      },
      {
        path: 'project-attributes-change-log',
        loadComponent: () =>
          import('./project-attributes-change-log/project-attributes-change-log').then(
            ({ ProjectAttributesChangeLogPage }) => ProjectAttributesChangeLogPage,
          ),
      },
      {
        path: 'store-expense-orders-history',
        loadComponent: () =>
          import('./store-expense-orders-history/store-expense-orders-history').then(
            ({ StoreExpenseOrdersHistoryPage }) => StoreExpenseOrdersHistoryPage,
          ),
      },
      {
        path: 'takeoff-release-log',
        loadComponent: () =>
          import('./takeoff-release-log/takeoff-release-log').then(
            ({ TakeoffReleaseLogPage }) => TakeoffReleaseLogPage,
          ),
      },
      {
        path: 'inventory-expense-release-log',
        loadComponent: () =>
          import('./inventory-expense-release-log/inventory-expense-release-log').then(
            ({ InventoryExpenseReleaseLogPage }) => InventoryExpenseReleaseLogPage,
          ),
      },
      {
        path: 'planos-by-dept',
        loadComponent: () =>
          import('./planos-by-dept/planos-by-dept').then(
            ({ PlanosByDeptPage }) => PlanosByDeptPage,
          ),
      },
      {
        path: 'historical-takeoff-summary',
        loadComponent: () =>
          import('./historical-takeoff-summary/historical-takeoff-summary').then(
            ({ HistoricalTakeoffSummaryPage }) => HistoricalTakeoffSummaryPage,
          ),
      },
      {
        path: 'pro-track-sales-floor-spec',
        loadComponent: () =>
          import('./pro-track-sales-floor-spec/pro-track-sales-floor-spec').then(
            ({ ProTrackSalesFloorSpecPage }) => ProTrackSalesFloorSpecPage,
          ),
      },
      {
        path: 'item-master',
        loadComponent: () =>
          import('./item-master/item-master').then(({ ItemMasterPage }) => ItemMasterPage),
      },
      {
        path: 'dp-nmsc-order-line',
        loadComponent: () =>
          import('./dp-nmsc-order-line/dp-nmsc-order-line').then(
            ({ DpNmscOrderLinePage }) => DpNmscOrderLinePage,
          ),
      },
      {
        path: 'project-status',
        loadComponent: () =>
          import('./project-status/project-status').then(
            ({ ProjectStatusPage }) => ProjectStatusPage,
          ),
      },
      {
        path: 'sales-orders-initial',
        loadComponent: () =>
          import('./sales-orders-initial/sales-orders-initial').then(
            ({ SalesOrdersInitialPage }) => SalesOrdersInitialPage,
          ),
      },
      {
        path: 'sales-orders-zero-dollar-adjustments',
        loadComponent: () =>
          import('./sales-orders-zero-dollar-adjustments/sales-orders-zero-dollar-adjustments').then(
            ({ SalesOrdersZeroDollarAdjustmentsPage }) => SalesOrdersZeroDollarAdjustmentsPage,
          ),
      },
      {
        path: 'sales-order-shipping',
        loadComponent: () =>
          import('./sales-order-shipping/sales-order-shipping').then(
            ({ SalesOrderShippingPage }) => SalesOrderShippingPage,
          ),
      },
      {
        path: 'sales-orders-asn',
        loadComponent: () =>
          import('./sales-orders-asn/sales-orders-asn').then(
            ({ SalesOrdersAsnPage }) => SalesOrdersAsnPage,
          ),
      },
      {
        path: 'sales-orders-receipt',
        loadComponent: () =>
          import('./sales-orders-receipt/sales-orders-receipt').then(
            ({ SalesOrdersReceiptPage }) => SalesOrdersReceiptPage,
          ),
      },
      {
        path: 'sales-orders-sap-verification',
        loadComponent: () =>
          import('./sales-orders-sap-verification/sales-orders-sap-verification').then(
            ({ SalesOrdersSapVerificationPage }) => SalesOrdersSapVerificationPage,
          ),
      },
      {
        path: 'inventory-comparison',
        loadComponent: () =>
          import('./inventory-comparison/inventory-comparison').then(
            ({ InventoryComparisonPage }) => InventoryComparisonPage,
          ),
      },
      {
        path: 'project-fiscal-year-change-log',
        loadComponent: () =>
          import('./project-fiscal-year-change-log/project-fiscal-year-change-log').then(
            ({ ProjectFiscalYearChangeLogPage }) => ProjectFiscalYearChangeLogPage,
          ),
      },
    ],
  },
];
